import { render, staticRenderFns } from "./settingLink.vue?vue&type=template&id=8c4b464a&scoped=true&"
import script from "./settingLink.vue?vue&type=script&lang=js&"
export * from "./settingLink.vue?vue&type=script&lang=js&"
import style0 from "./settingLink.vue?vue&type=style&index=0&id=8c4b464a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4b464a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
